
import React, {Component} from 'react';
import {connect} from 'react-redux'
import ReportGeneralTable from './ReportGeneralTable'
import WithholdingTaxDoc from '../doc/WithholdingTaxDoc'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome';
import { Popover, OverlayTrigger, Breadcrumb, DropdownButton, MenuItem } from 'react-bootstrap';
import {Checkbox} from 'react-icheck'
import IframeModal from '../../component/element/IframeModal'
import {compose} from 'redux'
import withSizes from 'react-sizes'
var NotificationSystem = require('react-notification-system');
class ReportWithholdingTaxPage extends Component {

  
  constructor(...args){
    super(...args)
    this.state = {showTable:true,check:[],data:[],isCheckAll:false,docNo:'',data_count:0,activePage:1,start:0,showSelectMenu:false}
    this.refTable = null
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }

  showTable(){
    this.setState({showTable:true})
    if(this.refTable!==null)
      this.refTable.refreshTable()  
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    this.onIconClick(item.withholdingtax_no)
    if(this.props.onDocShow!==undefined){
      this.props.onDocShow(item.withholdingtax_no)
    }
  }

  onDocNew(){
    this.setState({showTable:false},()=>{
      let that = this
      this.refs.genDoc.getWrappedInstance().loadNewDoc(function(item){
        if(that.props.onDocShow!==undefined){
          that.props.onDocShow(item.withholdingtax_no)
        }
      })
    })    
  }


  loadData(year,month,day,searchBy,query,activePage,itemPerPage,is_check,callback){
    ReportStore.loadWithholdingTaxList('all',year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result,is_check)
      this.setState({activePage:activePage,start:activePage*itemPerPage})
      callback(result)
    })
  }

  loadDataRange(start,end,searchBy,query,activePage,itemPerPage,is_check,callback) {
    ReportStore.loadWithholdingTaxListRange('all',start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result,is_check)
      this.setState({activePage:activePage,start:activePage*itemPerPage})
      callback(result)
    })
  }

  processData(result,is_check=false){
    let {check} = this.state
    result.data = result.data.map((item,index)=>{
      item = Object.assign({check:false},item)
      return item
    })
    if ((is_check&&check.length===0)||(!is_check))
      this.setState({showSelectMenu:false,isCheckAll:false,data:result.data,check:new Array(result.data_count*1).fill(false)})
    else
      this.setState({data:result.data})
  }

  renderStatus(status,row){
    let {messages} = this.props
    let result = (<span></span>)

    if (row.status==='0') {
      result = (<span className="label label-default" data-value="0">{messages['Start']}</span>)
    }else if (row.status==='1') {
      result = (<span className="label label-warning" data-value="1">{messages['Under Repair']}</span>)
    } else if (row.status==='2') {
      result = (<span className="label label-primary" data-value="2">{messages['Wait For Delivery']}</span>)
    } else if (row.status==='3') {
      result = (<span className="label label-success" data-value="3">{messages['Work Done']}</span>)
    } else if (row.status==='5') {
      result = (<span className="label label-primary" data-value="5">{messages['Wait For Delivery']}</span>)
    } else{
      result = (<span></span>)
    }

    return result
  }

  onIconClick(workNo,e) {
    
      this.setState({showTable:false,docNo:workNo},()=>{
        this.refs.genDoc.getWrappedInstance().loadData(workNo)
      })  
   
  }

  onMenuClick(e){
    let {check,data} = this.state
    let ind=0;
    let checkItems = data.reduce((rresult,item)=>{
      if(check[ind]){
        rresult.push(item)
      }
      ind++
      return rresult
    },[])
    if (checkItems.length>0) {
      //this.setState({showTable:false})
      if (e==='receipt') {
        if(window.create_new_receipt_from_invoice!==undefined){
          window.create_new_receipt_from_invoice(checkItems,function(){
            //Work Callback
          })
        }
      } else if (e==='taxinvoice') {
        if(window.create_new_taxinvoice_from_invoice!==undefined){
          //this.setState({showTable:false})
          window.create_new_taxinvoice_from_invoice(checkItems,()=>{
            //Work Callback
          })
        }
      }
    }    
  }

  // onPrintBillingClick(e) {
  //   let {check,data} = this.state
  //   // let _item = {}
  //   let withholdingtax_nos = []
  //   data.forEach(function(item,index) {
  //     if (check[index]) {
  //       // _item = item
  //       withholdingtax_nos.push(item.withholdingtax_no)
  //     }
  //   })
    
  //   let withholdingtax_no = withholdingtax_nos.join()
  //   let url = ''
  //   if (process.env.NODE_ENV === "development") {
  //     url  = './?startPage=PrintKKCBillingNoteCompany&ivlist='+withholdingtax_no
  //   } else{
  //     url = './pdf/v2/?startPage=PrintKKCBillingNoteCompany&ivlist='+withholdingtax_no
  //   }
  //   this.refs.iframe.getWrappedInstance().loadUrl(url)
  // }

  onCheckChange(rowIndex){
    let {showSelectMenu,data,check} = this.state

    let ind=0;
    let checkItems = data.reduce((rresult,item)=>{
      if(check[ind]){
        rresult.push(item)
      }      
      ind++;
      return rresult
    },[])
    //Before check
    if(!check[rowIndex] && !this.validateSameCustomer(data[rowIndex],checkItems)){
      //Notify 
      // this.setState({showSelectEror:true})
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'กรุณาเลือกรายการชื่อลูกค้าเดียวกัน เพื่อทำรายการ',
        level: 'error',
        position: 'tc'
      });
      return;
    }
    // check[rowIndex] = !check[rowIndex]
    if (check[rowIndex]===false)
      check[rowIndex] = data[rowIndex]
    else
      check[rowIndex] = false

    showSelectMenu = false
    check.map((item,index)=>{
      if(item){
        showSelectMenu = true
      }
      return item
    })
    this.setState({check:check,showSelectMenu:showSelectMenu},()=>{
      let isCheckAll = check.indexOf(false)===-1?true:false
      this.setState({isCheckAll:isCheckAll})
    })
  }

  validateSameCustomer(newItem,checkItems){
    let valid = true
    checkItems.map((item,index)=>{      
      if(item.customer_name!==newItem.customer_name){
        valid = false
      }
      return item
    })

    return valid
  }

  onCheckAll() {
    let {data,isCheckAll,check} = this.state
    if (data.length===0)
      return false

    if (!isCheckAll) {
      let newCheck = check.map((item,index)=>{
        return data[index]
      })
      this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})  
    } else {
      let newCheck = check.map((item,index)=>{
        item = false
        return item
      })
      this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
    }    
  }

  onRenderCheckAll(key) {
    return(
      <th key={Math.random()} className={'text-center'} style={{width:'50px',maxWidth:'50px'}}>
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        >
        </Checkbox>
      </th>
    )
  }

  onPrintShippingLabelClick(e) {
    let {check,data} = this.state
    let doc_nos = []
    check.forEach(function(item,index) {
      if (item!==false) {
        doc_nos.push(item.withholdingtax_no)
      }
    })
    let doc_no = doc_nos.join()
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = './?startPage=PrintShippingLabel&idlist='+doc_no+'&doc=withholdingtax'
    } else{
      url = './pdf/v2/?startPage=PrintShippingLabel&idlist='+doc_no+'&doc=withholdingtax'
    }
    this.refs.iframe.loadUrl(url)
  }

  onRenderColumn(data,col,row,rowIndex){ 
      let {messages} = this.props
      let {check} = this.state
    
      if(col==='check'){
        return (<Checkbox    
          onChange={this.onCheckChange.bind(this,rowIndex)}      
          checked={check[rowIndex]?true:false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        />)
      }else if(col==='status'){ 
        return this.renderStatus(data,row)
      } else if (col==='withholdingtax_no') {
        if (data!=="") {
          let title = messages['Repair Work']+" "+data
          let popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title={title}>
              <strong>{messages['Click Icon To View Worksheet']}</strong>
            </Popover>
          )

          return (
            <span>
              {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,row.withholdingtax_no)} className="text-blue" name='file-text-o'/></OverlayTrigger>
            </span>
          )
        }
      } else{ 
        return (<span>{data}</span>)
      }
  }

  onDocClose(){
    this.setState({docNo:''})
    this.showTable() 
  }

  onTypePrintSelect(key) {
    this.onPrintShippingLabelClick()
  }

  render(){
    let {messages} = this.props
    let {showTable,showSelectMenu} = this.state
    const headerTitles = [
      {title:'',width:'50px',checkAll:true},
      {title:messages['Date'],width:'100px'},
      {title:messages['Document number'],width:'120px'},
      {title:messages['Withholding name'],width:'200px'},
      {title:messages['Form'],width:'100px'},
      {title:messages['Amount'],width:'100px'},
      {title:messages['Tax deduction'],width:'100px'},
      {title:messages['Payment amount'],width:'120px'},
      {title:messages['Status'],width:'100px'}     
    ]
    const searchOptions = [
      {
        label: messages['Document number'],
        value: 'withholdingtax_no'
      },
      {
        label: messages['Withholding name'],
        value: 'customer_name'
      },
      {
        label: messages['Form'],
        value: 'form_id'
      }
    ]
    return (
      <div>
        <div style={{display:showTable?'block':'none'}}>
          <ReportGeneralTable 
          onRef={(ref)=>{this.refTable = ref}}
          title={messages['Withholding']} 
          newTitle={messages['Add Item']}
          showNewButton={true}
          headerTitles={headerTitles}
          bodyColumn={['check','issued_date','withholdingtax_no','customer_name','form_id','amount','withholding_amount','payment_amount','status']}
          excludeClickColumn={['check','withholdingtax_no','print']}
          searchOptions={searchOptions}          
          searchBy={'withholdingtax_no'}
          loadData={this.loadData.bind(this)}
          loadDataRange={this.loadDataRange.bind(this)}
          onRenderColumn={this.onRenderColumn.bind(this)}
          onRowSelect={this.onRowSelect.bind(this)} 
          onRenderCheckAll={this.onRenderCheckAll.bind(this)}  
          onDocNew={this.onDocNew.bind(this)}
          showPrintButton={true}
          docType={'withholdingtax'}
          showSelectMenu={showSelectMenu}
          printTitle={messages['Print Document']}
          onTypePrintSelect={this.onTypePrintSelect.bind(this)}   
          isMobile={this.props.isMobile}
          mobileFieldMap={{title:'customer_name',amount:'amount',sub_title:'withholdingtax_no',date:'issued_date',status:'status',sub_status:''}}
          renderWorkStatus={this.renderStatus.bind(this)}
          />
        </div>
        <div style={{display:!showTable?'block':'none'}}>
          <Breadcrumb>
            <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}><FontAwesome name="table"/> {messages['Withholding table']}</Breadcrumb.Item>
            <Breadcrumb.Item href="#" active>
              <FontAwesome name='file-o'/> {messages['Withholding']} {this.state.docNo}
            </Breadcrumb.Item>            
          </Breadcrumb>
          <WithholdingTaxDoc
            title={messages['Withholding']} 
            ref='genDoc' 
            onClose={this.onDocClose.bind(this)}
          />
        </div>
        <IframeModal ref='iframe' title={messages['Print Document']}/>
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default ReportWithholdingTaxPage = compose(connect(
  (state) => ({messages: state.message.view.report.ReportWithholdingTaxPage}),null,null,{withRef:true}
),withSizes(mapSizesToProps))(ReportWithholdingTaxPage);




// WEBPACK FOOTER //
// ./src/view/report/ReportWithholdingTaxPage.js